import { render, staticRenderFns } from "./clickVIVO.vue?vue&type=template&id=51c491ff&scoped=true"
import script from "./clickVIVO.vue?vue&type=script&lang=js"
export * from "./clickVIVO.vue?vue&type=script&lang=js"
import style0 from "./clickVIVO.vue?vue&type=style&index=0&id=51c491ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c491ff",
  null
  
)

export default component.exports